import React, { useState } from "react";
import { useErrorHandler } from "../../../hooks";
import DialogFormBuilder from "../../../components/dialog-form-builder";
import glassesService from "../../../services/glasses.service";
import { Button } from "@material-ui/core";
import ConfirmModalContent from "../../../components/confirm-modal-content";

const form = [
    {
        _type: "filePicker",
        name: "modelObject",
        label: "مدل سه بعدی",
        accept: ".glb, .gltf",
    },
    {
        _type: "textField",
        name: "smallScale",
        label: "کوچک",
        type: "number",
    },
    {
        _type: "textField",
        name: "mediumScale",
        label: "متوسط",
        type: "number",
    },
    {
        _type: "textField",
        name: "largScale",
        label: "بزرگ",
        type: "number",
    }
];
export default function ObjectModalContent({ close, data, extra, parent }) {
    const { id } = data;
    let scales = data?.scales ?? null;
    const errorHandler = useErrorHandler();

    const [confirmDeleteModal, setConfirmDeleteModal] = useState(false)

    const handleSubmit = async (model, { setSubmitting }) => {
        const { error } = await glassesService.uploadModel(id, model);
        setSubmitting(false);
        if (error) return errorHandler(error);
        close(true);
    };

    const handleRemove3D = async () => {
        const { error } = await glassesService.deleteModel(id);
        if (error) return errorHandler(error);
        close(true);
    }

    if (confirmDeleteModal) {
        return (
            <ConfirmModalContent
                title="حذف مدل سه بعدی"
                description="آیا از حذف مدل سه بعدی اطمینان دارید؟"
                confirmText="حدف شود"
                close={() => setConfirmDeleteModal(false)}
                onConfirm={handleRemove3D}
            />
        )
    }

    if(scales){
        scales = JSON.parse(scales);
    }

    return (
        <>
            <DialogFormBuilder
                {...{
                    close,
                    title: "مدل سه بعدی",
                    initialValues: {...scales},
                    handleSubmit,
                    form,
                    submitLabel: "ذخیره",

                    actionChildren: (isSubmitting) => {
                        return (
                            <div className="action3dModal">
                                <div>
                                    <Button style={{ color: "red" }} onClick={() => setConfirmDeleteModal(true)}>
                                        حذف
                                    </Button>
                                </div>
                                <div>
                                    <Button onClick={close} color="primary" disabled={isSubmitting}>
                                        لغو
                                    </Button>
                                    <Button
                                        type="submit"
                                        disabled={isSubmitting}
                                        variant="contained"
                                        color="primary"
                                    >
                                        ذخیره
                                    </Button>
                                </div>
                            </div>
                        )
                    }
                }}
            />
        </>
    );
}
